// PrimeReact
import { Splitter, SplitterPanel } from "primereact/splitter";

// Toolkit
import {
  Drawer,
  DrawerContent,
  PanelWithDrawers,
  TopPanel,
} from "sj-ui-toolkit/src/atlas/components/PanelWithDrawers";
import { C, themeClasses as T } from "sj-ui-toolkit/src/atlas/utils/themeClasses";

// Context
import { useTournamentContext } from "../../../context/TournamentContext.jsx";

// Sub-components
import Notes from "../Notes/Notes";
import ResourcesList from "../Resources/ResourcesList";
import LeftPanel from "./LeftPanel/LeftPanel.jsx";
import RightPanel from "./RightPanel/RightPanel.jsx";
import TournamentStart from "./TournamentStart.jsx";
import { VideoProvider } from "./VideoProvider.jsx";

// Styles
import S from "../_Lesson.module.scss";

// Main component
const VideoLesson = ({ lessonDetails, tournamentUuid, onLessonFinish, exerciseOnly }) => {
  const { tournamentLessonNotStarted } = useTournamentContext();

  return (
    <VideoProvider
      lessonDetails={lessonDetails}
      tournamentUuid={tournamentUuid}
      onLessonFinish={onLessonFinish}
      exerciseOnly={exerciseOnly}
    >
      {tournamentUuid && tournamentLessonNotStarted && <TournamentStart />}
      <Splitter className={C(T.splitterGap, "max-h-full h-full")}>
        <SplitterPanel
          size={30}
          minSize={20}
          className={C("flex flex-col max-h-full", S.leftPanel)}
        >
          <PanelWithDrawers className="max-h-full">
            <TopPanel className={C("pr-3", S.leftPanelScroll)}>
              <LeftPanel lessonDetails={lessonDetails} />
            </TopPanel>
            {!exerciseOnly && (
              <Drawer
                startOpen={true}
                initialHeight="50%"
                title="Notes"
                className={C(T.bgElevation1, "pr-3 rounded-t-sm")}
              >
                <DrawerContent title="Notes" className="h-full overflow-y-auto">
                  <Notes lessonId={lessonDetails.id} />
                </DrawerContent>
                {lessonDetails.resources && (
                  <DrawerContent title="Resources" className="h-full overflow-y-auto">
                    <ResourcesList resources={lessonDetails.resources} />
                  </DrawerContent>
                )}
              </Drawer>
            )}
          </PanelWithDrawers>
        </SplitterPanel>
        <SplitterPanel className="min-w-0 overflow-hidden h-full" size={70} minSize={40}>
          <RightPanel lessonDetails={lessonDetails} />
        </SplitterPanel>
      </Splitter>
    </VideoProvider>
  );
};

export default VideoLesson;
